var map = {
	"./ar/about": [
		82658,
		2658
	],
	"./ar/about.json": [
		82658,
		2658
	],
	"./ar/apps": [
		88452,
		8452
	],
	"./ar/apps.json": [
		88452,
		8452
	],
	"./ar/chapter": [
		56832,
		6832
	],
	"./ar/chapter.json": [
		56832,
		6832
	],
	"./ar/collection": [
		58376,
		8376
	],
	"./ar/collection.json": [
		58376,
		8376
	],
	"./ar/common": [
		11111,
		1111
	],
	"./ar/common.json": [
		11111,
		1111
	],
	"./ar/developers": [
		16242,
		6242
	],
	"./ar/developers.json": [
		16242,
		6242
	],
	"./ar/error": [
		64196,
		4196
	],
	"./ar/error.json": [
		64196,
		4196
	],
	"./ar/home": [
		50609,
		609
	],
	"./ar/home.json": [
		50609,
		609
	],
	"./ar/login": [
		44927,
		4927
	],
	"./ar/login.json": [
		44927,
		4927
	],
	"./ar/privacy": [
		40556,
		556
	],
	"./ar/privacy.json": [
		40556,
		556
	],
	"./ar/product-updates": [
		51896,
		1896
	],
	"./ar/product-updates.json": [
		51896,
		1896
	],
	"./ar/profile": [
		45340,
		5340
	],
	"./ar/profile.json": [
		45340,
		5340
	],
	"./ar/quick-links": [
		82937,
		2180
	],
	"./ar/quick-links.json": [
		82937,
		2180
	],
	"./ar/quran-reader": [
		61763,
		4221
	],
	"./ar/quran-reader.json": [
		61763,
		4221
	],
	"./ar/radio": [
		32772,
		2772
	],
	"./ar/radio.json": [
		32772,
		2772
	],
	"./ar/reciter": [
		160,
		160
	],
	"./ar/reciter.json": [
		160,
		160
	],
	"./ar/search": [
		54239,
		4239
	],
	"./ar/search.json": [
		54239,
		4239
	],
	"./ar/support": [
		19847,
		9847
	],
	"./ar/support.json": [
		19847,
		9847
	],
	"./ar/surah-info": [
		4198,
		4198
	],
	"./ar/surah-info.json": [
		4198,
		4198
	],
	"./ar/tajweed": [
		72419,
		2419
	],
	"./ar/tajweed.json": [
		72419,
		2419
	],
	"./bn/about": [
		96913,
		6913
	],
	"./bn/about.json": [
		96913,
		6913
	],
	"./bn/apps": [
		79618,
		9618
	],
	"./bn/apps.json": [
		79618,
		9618
	],
	"./bn/chapter": [
		97747,
		7747
	],
	"./bn/chapter.json": [
		97747,
		7747
	],
	"./bn/collection": [
		15603,
		5603
	],
	"./bn/collection.json": [
		15603,
		5603
	],
	"./bn/common": [
		50371,
		371
	],
	"./bn/common.json": [
		50371,
		371
	],
	"./bn/developers": [
		32966,
		2966
	],
	"./bn/developers.json": [
		32966,
		2966
	],
	"./bn/error": [
		83328,
		6521
	],
	"./bn/error.json": [
		83328,
		6521
	],
	"./bn/home": [
		82481,
		2481
	],
	"./bn/home.json": [
		82481,
		2481
	],
	"./bn/login": [
		81902,
		1902
	],
	"./bn/login.json": [
		81902,
		1902
	],
	"./bn/privacy": [
		34291,
		4291
	],
	"./bn/privacy.json": [
		34291,
		4291
	],
	"./bn/product-updates": [
		7596,
		7596
	],
	"./bn/product-updates.json": [
		7596,
		7596
	],
	"./bn/profile": [
		10188,
		188
	],
	"./bn/profile.json": [
		10188,
		188
	],
	"./bn/quick-links": [
		24464,
		4464
	],
	"./bn/quick-links.json": [
		24464,
		4464
	],
	"./bn/quran-reader": [
		31260,
		1260
	],
	"./bn/quran-reader.json": [
		31260,
		1260
	],
	"./bn/radio": [
		25772,
		5772
	],
	"./bn/radio.json": [
		25772,
		5772
	],
	"./bn/reciter": [
		53695,
		3695
	],
	"./bn/reciter.json": [
		53695,
		3695
	],
	"./bn/search": [
		90067,
		67
	],
	"./bn/search.json": [
		90067,
		67
	],
	"./bn/support": [
		11906,
		1906
	],
	"./bn/support.json": [
		11906,
		1906
	],
	"./bn/surah-info": [
		27050,
		7050
	],
	"./bn/surah-info.json": [
		27050,
		7050
	],
	"./bn/tajweed": [
		2552,
		2552
	],
	"./bn/tajweed.json": [
		2552,
		2552
	],
	"./en/about": [
		49740,
		9740
	],
	"./en/about.json": [
		49740,
		9740
	],
	"./en/apps": [
		46807,
		6807
	],
	"./en/apps.json": [
		46807,
		6807
	],
	"./en/chapter": [
		97821,
		7821
	],
	"./en/chapter.json": [
		97821,
		7821
	],
	"./en/collection": [
		49421,
		9421
	],
	"./en/collection.json": [
		49421,
		9421
	],
	"./en/common": [
		40464,
		464
	],
	"./en/common.json": [
		40464,
		464
	],
	"./en/developers": [
		44663,
		4663
	],
	"./en/developers.json": [
		44663,
		4663
	],
	"./en/error": [
		50394,
		394
	],
	"./en/error.json": [
		50394,
		394
	],
	"./en/home": [
		12482,
		2482
	],
	"./en/home.json": [
		12482,
		2482
	],
	"./en/login": [
		16318,
		6318
	],
	"./en/login.json": [
		16318,
		6318
	],
	"./en/privacy": [
		2297,
		2297
	],
	"./en/privacy.json": [
		2297,
		2297
	],
	"./en/product-updates": [
		21924,
		1924
	],
	"./en/product-updates.json": [
		21924,
		1924
	],
	"./en/profile": [
		81140,
		1140
	],
	"./en/profile.json": [
		81140,
		1140
	],
	"./en/quick-links": [
		36667,
		6667
	],
	"./en/quick-links.json": [
		36667,
		6667
	],
	"./en/quran-reader": [
		63151,
		3151
	],
	"./en/quran-reader.json": [
		63151,
		3151
	],
	"./en/radio": [
		40333,
		333
	],
	"./en/radio.json": [
		40333,
		333
	],
	"./en/reciter": [
		42121,
		2121
	],
	"./en/reciter.json": [
		42121,
		2121
	],
	"./en/search": [
		17842,
		7842
	],
	"./en/search.json": [
		17842,
		7842
	],
	"./en/support": [
		69251,
		9251
	],
	"./en/support.json": [
		69251,
		9251
	],
	"./en/surah-info": [
		19435,
		9435
	],
	"./en/surah-info.json": [
		19435,
		9435
	],
	"./en/tajweed": [
		27848,
		7848
	],
	"./en/tajweed.json": [
		27848,
		7848
	],
	"./fa/about": [
		62755,
		2755
	],
	"./fa/about.json": [
		62755,
		2755
	],
	"./fa/apps": [
		25265,
		5265
	],
	"./fa/apps.json": [
		25265,
		5265
	],
	"./fa/chapter": [
		24280,
		4280
	],
	"./fa/chapter.json": [
		24280,
		4280
	],
	"./fa/collection": [
		79382,
		9382
	],
	"./fa/collection.json": [
		79382,
		9382
	],
	"./fa/common": [
		70512,
		512
	],
	"./fa/common.json": [
		70512,
		512
	],
	"./fa/developers": [
		62319,
		2319
	],
	"./fa/developers.json": [
		62319,
		2319
	],
	"./fa/error": [
		25016,
		3745
	],
	"./fa/error.json": [
		25016,
		3745
	],
	"./fa/home": [
		17859,
		7859
	],
	"./fa/home.json": [
		17859,
		7859
	],
	"./fa/login": [
		18963,
		8963
	],
	"./fa/login.json": [
		18963,
		8963
	],
	"./fa/privacy": [
		98917,
		8917
	],
	"./fa/privacy.json": [
		98917,
		8917
	],
	"./fa/product-updates": [
		49264,
		9891
	],
	"./fa/product-updates.json": [
		49264,
		9891
	],
	"./fa/profile": [
		92620,
		3980
	],
	"./fa/profile.json": [
		92620,
		3980
	],
	"./fa/quick-links": [
		20689,
		689
	],
	"./fa/quick-links.json": [
		20689,
		689
	],
	"./fa/quran-reader": [
		56847,
		6847
	],
	"./fa/quran-reader.json": [
		56847,
		6847
	],
	"./fa/radio": [
		67110,
		7110
	],
	"./fa/radio.json": [
		67110,
		7110
	],
	"./fa/reciter": [
		77097,
		1248
	],
	"./fa/reciter.json": [
		77097,
		1248
	],
	"./fa/search": [
		20074,
		74
	],
	"./fa/search.json": [
		20074,
		74
	],
	"./fa/support": [
		86540,
		6540
	],
	"./fa/support.json": [
		86540,
		6540
	],
	"./fa/surah-info": [
		81131,
		1131
	],
	"./fa/surah-info.json": [
		81131,
		1131
	],
	"./fa/tajweed": [
		85510,
		5510
	],
	"./fa/tajweed.json": [
		85510,
		5510
	],
	"./fr/about": [
		85754,
		5754
	],
	"./fr/about.json": [
		85754,
		5754
	],
	"./fr/apps": [
		15582,
		5582
	],
	"./fr/apps.json": [
		15582,
		5582
	],
	"./fr/chapter": [
		98010,
		8010
	],
	"./fr/chapter.json": [
		98010,
		8010
	],
	"./fr/collection": [
		15926,
		5926
	],
	"./fr/collection.json": [
		15926,
		5926
	],
	"./fr/common": [
		45167,
		5167
	],
	"./fr/common.json": [
		45167,
		5167
	],
	"./fr/developers": [
		36538,
		6538
	],
	"./fr/developers.json": [
		36538,
		6538
	],
	"./fr/error": [
		82716,
		2716
	],
	"./fr/error.json": [
		82716,
		2716
	],
	"./fr/home": [
		31660,
		1660
	],
	"./fr/home.json": [
		31660,
		1660
	],
	"./fr/login": [
		76626,
		6626
	],
	"./fr/login.json": [
		76626,
		6626
	],
	"./fr/privacy": [
		26906,
		6906
	],
	"./fr/privacy.json": [
		26906,
		6906
	],
	"./fr/product-updates": [
		98750,
		8750
	],
	"./fr/product-updates.json": [
		98750,
		8750
	],
	"./fr/profile": [
		51763,
		1763
	],
	"./fr/profile.json": [
		51763,
		1763
	],
	"./fr/quick-links": [
		54833,
		4833
	],
	"./fr/quick-links.json": [
		54833,
		4833
	],
	"./fr/quran-reader": [
		55274,
		5274
	],
	"./fr/quran-reader.json": [
		55274,
		5274
	],
	"./fr/radio": [
		17325,
		7325
	],
	"./fr/radio.json": [
		17325,
		7325
	],
	"./fr/reciter": [
		24777,
		4777
	],
	"./fr/reciter.json": [
		24777,
		4777
	],
	"./fr/search": [
		77194,
		7194
	],
	"./fr/search.json": [
		77194,
		7194
	],
	"./fr/support": [
		51517,
		1517
	],
	"./fr/support.json": [
		51517,
		1517
	],
	"./fr/surah-info": [
		70203,
		203
	],
	"./fr/surah-info.json": [
		70203,
		203
	],
	"./fr/tajweed": [
		39419,
		9419
	],
	"./fr/tajweed.json": [
		39419,
		9419
	],
	"./id/about": [
		49146,
		9146
	],
	"./id/about.json": [
		49146,
		9146
	],
	"./id/apps": [
		88816,
		8816
	],
	"./id/apps.json": [
		88816,
		8816
	],
	"./id/chapter": [
		11888,
		1888
	],
	"./id/chapter.json": [
		11888,
		1888
	],
	"./id/collection": [
		49451,
		9451
	],
	"./id/collection.json": [
		49451,
		9451
	],
	"./id/common": [
		81610,
		1610
	],
	"./id/common.json": [
		81610,
		1610
	],
	"./id/developers": [
		61597,
		1597
	],
	"./id/developers.json": [
		61597,
		1597
	],
	"./id/error": [
		72819,
		2819
	],
	"./id/error.json": [
		72819,
		2819
	],
	"./id/home": [
		96903,
		6903
	],
	"./id/home.json": [
		96903,
		6903
	],
	"./id/login": [
		74675,
		4675
	],
	"./id/login.json": [
		74675,
		4675
	],
	"./id/privacy": [
		10399,
		399
	],
	"./id/privacy.json": [
		10399,
		399
	],
	"./id/product-updates": [
		71573,
		1573
	],
	"./id/product-updates.json": [
		71573,
		1573
	],
	"./id/profile": [
		51702,
		1702
	],
	"./id/profile.json": [
		51702,
		1702
	],
	"./id/quick-links": [
		23168,
		3168
	],
	"./id/quick-links.json": [
		23168,
		3168
	],
	"./id/quran-reader": [
		93981,
		3981
	],
	"./id/quran-reader.json": [
		93981,
		3981
	],
	"./id/radio": [
		86174,
		6174
	],
	"./id/radio.json": [
		86174,
		6174
	],
	"./id/reciter": [
		56576,
		6576
	],
	"./id/reciter.json": [
		56576,
		6576
	],
	"./id/search": [
		20794,
		794
	],
	"./id/search.json": [
		20794,
		794
	],
	"./id/support": [
		18974,
		8974
	],
	"./id/support.json": [
		18974,
		8974
	],
	"./id/surah-info": [
		77717,
		7717
	],
	"./id/surah-info.json": [
		77717,
		7717
	],
	"./id/tajweed": [
		46233,
		6233
	],
	"./id/tajweed.json": [
		46233,
		6233
	],
	"./it/about": [
		216,
		216
	],
	"./it/about.json": [
		216,
		216
	],
	"./it/apps": [
		65396,
		5396
	],
	"./it/apps.json": [
		65396,
		5396
	],
	"./it/chapter": [
		47097,
		7097
	],
	"./it/chapter.json": [
		47097,
		7097
	],
	"./it/collection": [
		95656,
		5656
	],
	"./it/collection.json": [
		95656,
		5656
	],
	"./it/common": [
		9486,
		5134
	],
	"./it/common.json": [
		9486,
		5134
	],
	"./it/developers": [
		10626,
		626
	],
	"./it/developers.json": [
		10626,
		626
	],
	"./it/error": [
		91259,
		1259
	],
	"./it/error.json": [
		91259,
		1259
	],
	"./it/home": [
		53765,
		3765
	],
	"./it/home.json": [
		53765,
		3765
	],
	"./it/login": [
		91153,
		1153
	],
	"./it/login.json": [
		91153,
		1153
	],
	"./it/privacy": [
		94987,
		4987
	],
	"./it/privacy.json": [
		94987,
		4987
	],
	"./it/product-updates": [
		53558,
		3558
	],
	"./it/product-updates.json": [
		53558,
		3558
	],
	"./it/profile": [
		21618,
		1618
	],
	"./it/profile.json": [
		21618,
		1618
	],
	"./it/quick-links": [
		86406,
		6406
	],
	"./it/quick-links.json": [
		86406,
		6406
	],
	"./it/quran-reader": [
		95016,
		5016
	],
	"./it/quran-reader.json": [
		95016,
		5016
	],
	"./it/radio": [
		55570,
		5570
	],
	"./it/radio.json": [
		55570,
		5570
	],
	"./it/reciter": [
		39905,
		9905
	],
	"./it/reciter.json": [
		39905,
		9905
	],
	"./it/search": [
		5175,
		5175
	],
	"./it/search.json": [
		5175,
		5175
	],
	"./it/support": [
		88600,
		8600
	],
	"./it/support.json": [
		88600,
		8600
	],
	"./it/surah-info": [
		90940,
		940
	],
	"./it/surah-info.json": [
		90940,
		940
	],
	"./it/tajweed": [
		23442,
		3442
	],
	"./it/tajweed.json": [
		23442,
		3442
	],
	"./ms/about": [
		50029,
		29
	],
	"./ms/about.json": [
		50029,
		29
	],
	"./ms/apps": [
		96282,
		6282
	],
	"./ms/apps.json": [
		96282,
		6282
	],
	"./ms/chapter": [
		41641,
		1641
	],
	"./ms/chapter.json": [
		41641,
		1641
	],
	"./ms/collection": [
		73218,
		3218
	],
	"./ms/collection.json": [
		73218,
		3218
	],
	"./ms/common": [
		85223,
		5223
	],
	"./ms/common.json": [
		85223,
		5223
	],
	"./ms/developers": [
		6259,
		6259
	],
	"./ms/developers.json": [
		6259,
		6259
	],
	"./ms/error": [
		29620,
		9620
	],
	"./ms/error.json": [
		29620,
		9620
	],
	"./ms/home": [
		98950,
		8950
	],
	"./ms/home.json": [
		98950,
		8950
	],
	"./ms/login": [
		128,
		128
	],
	"./ms/login.json": [
		128,
		128
	],
	"./ms/privacy": [
		39746,
		9746
	],
	"./ms/privacy.json": [
		39746,
		9746
	],
	"./ms/product-updates": [
		56495,
		6495
	],
	"./ms/product-updates.json": [
		56495,
		6495
	],
	"./ms/profile": [
		83461,
		3461
	],
	"./ms/profile.json": [
		83461,
		3461
	],
	"./ms/quick-links": [
		1017,
		1017
	],
	"./ms/quick-links.json": [
		1017,
		1017
	],
	"./ms/quran-reader": [
		11242,
		1242
	],
	"./ms/quran-reader.json": [
		11242,
		1242
	],
	"./ms/radio": [
		3787,
		3787
	],
	"./ms/radio.json": [
		3787,
		3787
	],
	"./ms/reciter": [
		83546,
		3546
	],
	"./ms/reciter.json": [
		83546,
		3546
	],
	"./ms/search": [
		80561,
		561
	],
	"./ms/search.json": [
		80561,
		561
	],
	"./ms/support": [
		91036,
		1036
	],
	"./ms/support.json": [
		91036,
		1036
	],
	"./ms/surah-info": [
		89413,
		9413
	],
	"./ms/surah-info.json": [
		89413,
		9413
	],
	"./ms/tajweed": [
		71501,
		1501
	],
	"./ms/tajweed.json": [
		71501,
		1501
	],
	"./nl/about": [
		63113,
		3113
	],
	"./nl/about.json": [
		63113,
		3113
	],
	"./nl/apps": [
		30496,
		496
	],
	"./nl/apps.json": [
		30496,
		496
	],
	"./nl/chapter": [
		7451,
		7451
	],
	"./nl/chapter.json": [
		7451,
		7451
	],
	"./nl/collection": [
		75147,
		9409
	],
	"./nl/collection.json": [
		75147,
		9409
	],
	"./nl/common": [
		1211,
		1211
	],
	"./nl/common.json": [
		1211,
		1211
	],
	"./nl/developers": [
		96780,
		6780
	],
	"./nl/developers.json": [
		96780,
		6780
	],
	"./nl/error": [
		57744,
		7744
	],
	"./nl/error.json": [
		57744,
		7744
	],
	"./nl/home": [
		86385,
		6385
	],
	"./nl/home.json": [
		86385,
		6385
	],
	"./nl/login": [
		75083,
		5083
	],
	"./nl/login.json": [
		75083,
		5083
	],
	"./nl/privacy": [
		80100,
		100
	],
	"./nl/privacy.json": [
		80100,
		100
	],
	"./nl/product-updates": [
		29175,
		9175
	],
	"./nl/product-updates.json": [
		29175,
		9175
	],
	"./nl/profile": [
		86583,
		6583
	],
	"./nl/profile.json": [
		86583,
		6583
	],
	"./nl/quick-links": [
		45960,
		5960
	],
	"./nl/quick-links.json": [
		45960,
		5960
	],
	"./nl/quran-reader": [
		8322,
		8322
	],
	"./nl/quran-reader.json": [
		8322,
		8322
	],
	"./nl/radio": [
		13878,
		3878
	],
	"./nl/radio.json": [
		13878,
		3878
	],
	"./nl/reciter": [
		95073,
		5073
	],
	"./nl/reciter.json": [
		95073,
		5073
	],
	"./nl/search": [
		10308,
		308
	],
	"./nl/search.json": [
		10308,
		308
	],
	"./nl/support": [
		76263,
		6263
	],
	"./nl/support.json": [
		76263,
		6263
	],
	"./nl/surah-info": [
		48168,
		8168
	],
	"./nl/surah-info.json": [
		48168,
		8168
	],
	"./nl/tajweed": [
		7999,
		7999
	],
	"./nl/tajweed.json": [
		7999,
		7999
	],
	"./pt/about": [
		5891,
		5891
	],
	"./pt/about.json": [
		5891,
		5891
	],
	"./pt/apps": [
		1787,
		1787
	],
	"./pt/apps.json": [
		1787,
		1787
	],
	"./pt/chapter": [
		20833,
		833
	],
	"./pt/chapter.json": [
		20833,
		833
	],
	"./pt/collection": [
		99625,
		9625
	],
	"./pt/collection.json": [
		99625,
		9625
	],
	"./pt/common": [
		41400,
		1400
	],
	"./pt/common.json": [
		41400,
		1400
	],
	"./pt/developers": [
		21378,
		1378
	],
	"./pt/developers.json": [
		21378,
		1378
	],
	"./pt/error": [
		31374,
		1374
	],
	"./pt/error.json": [
		31374,
		1374
	],
	"./pt/home": [
		44766,
		4766
	],
	"./pt/home.json": [
		44766,
		4766
	],
	"./pt/login": [
		13192,
		3192
	],
	"./pt/login.json": [
		13192,
		3192
	],
	"./pt/privacy": [
		25283,
		5283
	],
	"./pt/privacy.json": [
		25283,
		5283
	],
	"./pt/product-updates": [
		13850,
		3850
	],
	"./pt/product-updates.json": [
		13850,
		3850
	],
	"./pt/profile": [
		22854,
		2854
	],
	"./pt/profile.json": [
		22854,
		2854
	],
	"./pt/quick-links": [
		64394,
		4394
	],
	"./pt/quick-links.json": [
		64394,
		4394
	],
	"./pt/quran-reader": [
		22527,
		2527
	],
	"./pt/quran-reader.json": [
		22527,
		2527
	],
	"./pt/radio": [
		72575,
		2575
	],
	"./pt/radio.json": [
		72575,
		2575
	],
	"./pt/reciter": [
		76804,
		6804
	],
	"./pt/reciter.json": [
		76804,
		6804
	],
	"./pt/search": [
		8302,
		8302
	],
	"./pt/search.json": [
		8302,
		8302
	],
	"./pt/support": [
		94109,
		4109
	],
	"./pt/support.json": [
		94109,
		4109
	],
	"./pt/surah-info": [
		48580,
		8580
	],
	"./pt/surah-info.json": [
		48580,
		8580
	],
	"./pt/tajweed": [
		89925,
		9925
	],
	"./pt/tajweed.json": [
		89925,
		9925
	],
	"./ru/about": [
		6217,
		6217
	],
	"./ru/about.json": [
		6217,
		6217
	],
	"./ru/apps": [
		95147,
		5147
	],
	"./ru/apps.json": [
		95147,
		5147
	],
	"./ru/chapter": [
		25758,
		5758
	],
	"./ru/chapter.json": [
		25758,
		5758
	],
	"./ru/collection": [
		2735,
		2735
	],
	"./ru/collection.json": [
		2735,
		2735
	],
	"./ru/common": [
		77247,
		7247
	],
	"./ru/common.json": [
		77247,
		7247
	],
	"./ru/developers": [
		57132,
		7132
	],
	"./ru/developers.json": [
		57132,
		7132
	],
	"./ru/error": [
		8104,
		8104
	],
	"./ru/error.json": [
		8104,
		8104
	],
	"./ru/home": [
		32503,
		2503
	],
	"./ru/home.json": [
		32503,
		2503
	],
	"./ru/login": [
		87653,
		7653
	],
	"./ru/login.json": [
		87653,
		7653
	],
	"./ru/privacy": [
		28771,
		8771
	],
	"./ru/privacy.json": [
		28771,
		8771
	],
	"./ru/product-updates": [
		45111,
		5111
	],
	"./ru/product-updates.json": [
		45111,
		5111
	],
	"./ru/profile": [
		87157,
		7157
	],
	"./ru/profile.json": [
		87157,
		7157
	],
	"./ru/quick-links": [
		69373,
		9373
	],
	"./ru/quick-links.json": [
		69373,
		9373
	],
	"./ru/quran-reader": [
		88041,
		8041
	],
	"./ru/quran-reader.json": [
		88041,
		8041
	],
	"./ru/radio": [
		69511,
		9511
	],
	"./ru/radio.json": [
		69511,
		9511
	],
	"./ru/reciter": [
		82554,
		2554
	],
	"./ru/reciter.json": [
		82554,
		2554
	],
	"./ru/search": [
		77193,
		7193
	],
	"./ru/search.json": [
		77193,
		7193
	],
	"./ru/support": [
		52074,
		2074
	],
	"./ru/support.json": [
		52074,
		2074
	],
	"./ru/surah-info": [
		84967,
		4967
	],
	"./ru/surah-info.json": [
		84967,
		4967
	],
	"./ru/tajweed": [
		42932,
		2932
	],
	"./ru/tajweed.json": [
		42932,
		2932
	],
	"./sq/about": [
		1471,
		1471
	],
	"./sq/about.json": [
		1471,
		1471
	],
	"./sq/apps": [
		75248,
		5248
	],
	"./sq/apps.json": [
		75248,
		5248
	],
	"./sq/chapter": [
		9636,
		9636
	],
	"./sq/chapter.json": [
		9636,
		9636
	],
	"./sq/collection": [
		38326,
		8326
	],
	"./sq/collection.json": [
		38326,
		8326
	],
	"./sq/common": [
		22937,
		2937
	],
	"./sq/common.json": [
		22937,
		2937
	],
	"./sq/developers": [
		86418,
		6418
	],
	"./sq/developers.json": [
		86418,
		6418
	],
	"./sq/error": [
		62322,
		2322
	],
	"./sq/error.json": [
		62322,
		2322
	],
	"./sq/home": [
		8951,
		8951
	],
	"./sq/home.json": [
		8951,
		8951
	],
	"./sq/login": [
		39725,
		9725
	],
	"./sq/login.json": [
		39725,
		9725
	],
	"./sq/privacy": [
		46448,
		6448
	],
	"./sq/privacy.json": [
		46448,
		6448
	],
	"./sq/product-updates": [
		90650,
		650
	],
	"./sq/product-updates.json": [
		90650,
		650
	],
	"./sq/profile": [
		96682,
		6682
	],
	"./sq/profile.json": [
		96682,
		6682
	],
	"./sq/quick-links": [
		36048,
		6048
	],
	"./sq/quick-links.json": [
		36048,
		6048
	],
	"./sq/quran-reader": [
		10476,
		476
	],
	"./sq/quran-reader.json": [
		10476,
		476
	],
	"./sq/radio": [
		705,
		5077
	],
	"./sq/radio.json": [
		705,
		5077
	],
	"./sq/reciter": [
		37257,
		7257
	],
	"./sq/reciter.json": [
		37257,
		7257
	],
	"./sq/search": [
		86609,
		6609
	],
	"./sq/search.json": [
		86609,
		6609
	],
	"./sq/support": [
		20801,
		801
	],
	"./sq/support.json": [
		20801,
		801
	],
	"./sq/surah-info": [
		16726,
		6726
	],
	"./sq/surah-info.json": [
		16726,
		6726
	],
	"./sq/tajweed": [
		24733,
		4733
	],
	"./sq/tajweed.json": [
		24733,
		4733
	],
	"./th/about": [
		47030,
		7030
	],
	"./th/about.json": [
		47030,
		7030
	],
	"./th/apps": [
		50249,
		249
	],
	"./th/apps.json": [
		50249,
		249
	],
	"./th/chapter": [
		6735,
		6735
	],
	"./th/chapter.json": [
		6735,
		6735
	],
	"./th/collection": [
		78294,
		8294
	],
	"./th/collection.json": [
		78294,
		8294
	],
	"./th/common": [
		63303,
		3303
	],
	"./th/common.json": [
		63303,
		3303
	],
	"./th/developers": [
		42529,
		2529
	],
	"./th/developers.json": [
		42529,
		2529
	],
	"./th/error": [
		75496,
		5496
	],
	"./th/error.json": [
		75496,
		5496
	],
	"./th/home": [
		61686,
		1686
	],
	"./th/home.json": [
		61686,
		1686
	],
	"./th/login": [
		98915,
		8535
	],
	"./th/login.json": [
		98915,
		8535
	],
	"./th/privacy": [
		51890,
		1890
	],
	"./th/privacy.json": [
		51890,
		1890
	],
	"./th/product-updates": [
		11329,
		1329
	],
	"./th/product-updates.json": [
		11329,
		1329
	],
	"./th/profile": [
		43671,
		3671
	],
	"./th/profile.json": [
		43671,
		3671
	],
	"./th/quick-links": [
		82010,
		2010
	],
	"./th/quick-links.json": [
		82010,
		2010
	],
	"./th/quran-reader": [
		31301,
		1301
	],
	"./th/quran-reader.json": [
		31301,
		1301
	],
	"./th/radio": [
		20364,
		364
	],
	"./th/radio.json": [
		20364,
		364
	],
	"./th/reciter": [
		95142,
		5142
	],
	"./th/reciter.json": [
		95142,
		5142
	],
	"./th/search": [
		15178,
		5178
	],
	"./th/search.json": [
		15178,
		5178
	],
	"./th/support": [
		90933,
		933
	],
	"./th/support.json": [
		90933,
		933
	],
	"./th/surah-info": [
		57855,
		7855
	],
	"./th/surah-info.json": [
		57855,
		7855
	],
	"./th/tajweed": [
		87880,
		7880
	],
	"./th/tajweed.json": [
		87880,
		7880
	],
	"./tr/about": [
		84602,
		4602
	],
	"./tr/about.json": [
		84602,
		4602
	],
	"./tr/apps": [
		12445,
		2445
	],
	"./tr/apps.json": [
		12445,
		2445
	],
	"./tr/chapter": [
		51528,
		1528
	],
	"./tr/chapter.json": [
		51528,
		1528
	],
	"./tr/collection": [
		38104,
		666
	],
	"./tr/collection.json": [
		38104,
		666
	],
	"./tr/common": [
		72973,
		2973
	],
	"./tr/common.json": [
		72973,
		2973
	],
	"./tr/developers": [
		60417,
		417
	],
	"./tr/developers.json": [
		60417,
		417
	],
	"./tr/error": [
		63493,
		7328
	],
	"./tr/error.json": [
		63493,
		7328
	],
	"./tr/home": [
		27646,
		7646
	],
	"./tr/home.json": [
		27646,
		7646
	],
	"./tr/login": [
		99237,
		9237
	],
	"./tr/login.json": [
		99237,
		9237
	],
	"./tr/privacy": [
		25937,
		5937
	],
	"./tr/privacy.json": [
		25937,
		5937
	],
	"./tr/product-updates": [
		22771,
		2771
	],
	"./tr/product-updates.json": [
		22771,
		2771
	],
	"./tr/profile": [
		74440,
		2140
	],
	"./tr/profile.json": [
		74440,
		2140
	],
	"./tr/quick-links": [
		44202,
		4202
	],
	"./tr/quick-links.json": [
		44202,
		4202
	],
	"./tr/quran-reader": [
		21552,
		1552
	],
	"./tr/quran-reader.json": [
		21552,
		1552
	],
	"./tr/radio": [
		64431,
		4431
	],
	"./tr/radio.json": [
		64431,
		4431
	],
	"./tr/reciter": [
		59535,
		2620
	],
	"./tr/reciter.json": [
		59535,
		2620
	],
	"./tr/search": [
		64171,
		4171
	],
	"./tr/search.json": [
		64171,
		4171
	],
	"./tr/support": [
		86015,
		6015
	],
	"./tr/support.json": [
		86015,
		6015
	],
	"./tr/surah-info": [
		55983,
		5983
	],
	"./tr/surah-info.json": [
		55983,
		5983
	],
	"./tr/tajweed": [
		40754,
		754
	],
	"./tr/tajweed.json": [
		40754,
		754
	],
	"./ur/about": [
		92239,
		2239
	],
	"./ur/about.json": [
		92239,
		2239
	],
	"./ur/apps": [
		54847,
		4847
	],
	"./ur/apps.json": [
		54847,
		4847
	],
	"./ur/chapter": [
		98510,
		8510
	],
	"./ur/chapter.json": [
		98510,
		8510
	],
	"./ur/collection": [
		22084,
		2084
	],
	"./ur/collection.json": [
		22084,
		2084
	],
	"./ur/common": [
		45597,
		5597
	],
	"./ur/common.json": [
		45597,
		5597
	],
	"./ur/developers": [
		57171,
		7171
	],
	"./ur/developers.json": [
		57171,
		7171
	],
	"./ur/error": [
		77140,
		7140
	],
	"./ur/error.json": [
		77140,
		7140
	],
	"./ur/home": [
		5321,
		5321
	],
	"./ur/home.json": [
		5321,
		5321
	],
	"./ur/login": [
		36602,
		6602
	],
	"./ur/login.json": [
		36602,
		6602
	],
	"./ur/privacy": [
		21419,
		1419
	],
	"./ur/privacy.json": [
		21419,
		1419
	],
	"./ur/product-updates": [
		83821,
		3821
	],
	"./ur/product-updates.json": [
		83821,
		3821
	],
	"./ur/profile": [
		58438,
		8438
	],
	"./ur/profile.json": [
		58438,
		8438
	],
	"./ur/quick-links": [
		73201,
		3201
	],
	"./ur/quick-links.json": [
		73201,
		3201
	],
	"./ur/quran-reader": [
		49639,
		9639
	],
	"./ur/quran-reader.json": [
		49639,
		9639
	],
	"./ur/radio": [
		10621,
		621
	],
	"./ur/radio.json": [
		10621,
		621
	],
	"./ur/reciter": [
		75279,
		5279
	],
	"./ur/reciter.json": [
		75279,
		5279
	],
	"./ur/search": [
		16037,
		6037
	],
	"./ur/search.json": [
		16037,
		6037
	],
	"./ur/support": [
		84183,
		4183
	],
	"./ur/support.json": [
		84183,
		4183
	],
	"./ur/surah-info": [
		506,
		506
	],
	"./ur/surah-info.json": [
		506,
		506
	],
	"./ur/tajweed": [
		44526,
		4526
	],
	"./ur/tajweed.json": [
		44526,
		4526
	],
	"./zh/about": [
		23318,
		3318
	],
	"./zh/about.json": [
		23318,
		3318
	],
	"./zh/apps": [
		33007,
		3007
	],
	"./zh/apps.json": [
		33007,
		3007
	],
	"./zh/chapter": [
		7503,
		7503
	],
	"./zh/chapter.json": [
		7503,
		7503
	],
	"./zh/collection": [
		11602,
		1602
	],
	"./zh/collection.json": [
		11602,
		1602
	],
	"./zh/common": [
		66671,
		6671
	],
	"./zh/common.json": [
		66671,
		6671
	],
	"./zh/developers": [
		53328,
		3328
	],
	"./zh/developers.json": [
		53328,
		3328
	],
	"./zh/error": [
		19846,
		9846
	],
	"./zh/error.json": [
		19846,
		9846
	],
	"./zh/home": [
		93056,
		3056
	],
	"./zh/home.json": [
		93056,
		3056
	],
	"./zh/login": [
		20292,
		292
	],
	"./zh/login.json": [
		20292,
		292
	],
	"./zh/privacy": [
		94699,
		4699
	],
	"./zh/privacy.json": [
		94699,
		4699
	],
	"./zh/product-updates": [
		65869,
		5869
	],
	"./zh/product-updates.json": [
		65869,
		5869
	],
	"./zh/profile": [
		98382,
		8382
	],
	"./zh/profile.json": [
		98382,
		8382
	],
	"./zh/quick-links": [
		85571,
		5571
	],
	"./zh/quick-links.json": [
		85571,
		5571
	],
	"./zh/quran-reader": [
		72056,
		2056
	],
	"./zh/quran-reader.json": [
		72056,
		2056
	],
	"./zh/radio": [
		21103,
		1103
	],
	"./zh/radio.json": [
		21103,
		1103
	],
	"./zh/reciter": [
		1454,
		1454
	],
	"./zh/reciter.json": [
		1454,
		1454
	],
	"./zh/search": [
		58020,
		8020
	],
	"./zh/search.json": [
		58020,
		8020
	],
	"./zh/support": [
		79306,
		9306
	],
	"./zh/support.json": [
		79306,
		9306
	],
	"./zh/surah-info": [
		62199,
		2199
	],
	"./zh/surah-info.json": [
		62199,
		2199
	],
	"./zh/tajweed": [
		40651,
		651
	],
	"./zh/tajweed.json": [
		40651,
		651
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 30242;
module.exports = webpackAsyncContext;